import { Sentry } from "../sentry";

export function captureClientError(error, context = {}) {
  try {
    Sentry.captureException(error, { extra: context });
  } catch (_) {
    /* ignore */
  }
}
